module.exports = __webpack_public_path__ + "img/criaai.eea13359.png";